import { Button, Flex, Result, Typography } from 'antd'

import { system } from '@eastcoal/common/config/system'
import { browserRedirect } from '@eastcoal/common/utils/browser'
import { downloadContent } from '@eastcoal/common/utils/filesaver'
import { normalizeUrl } from '@eastcoal/common/utils/url'

import { useRegisterStore } from '../hooks/useStore'
import { useRegisterStyles } from '../style'

const AUDIT_PERSON_CREATE_PAGE_PATH = '/audit/person/create'

export const RegisterResult = () => {
  const { phone = '', password = '' } = useRegisterStore(state => state.form)

  const downloadAccount = () => {
    downloadContent(
      `账号：${phone}\n密码：${password}`,
      '东方煤炭电子交易中心登录凭证.txt'
    )
  }

  const subTitle = (
    <Flex vertical gap={12}>
      <Flex align='center' gap={0} justify='center'>
        <div>您的登录账号为: {phone}</div>
        <Button type='link' onClick={downloadAccount}>
          下载账号密码
        </Button>
      </Flex>
      <Typography.Text>
        参与平台的交易业务之前，请记得先完成会员认证哦~
      </Typography.Text>
    </Flex>
  )

  const extra = (
    <Flex align='center' gap={24} justify='center'>
      <Button
        ghost
        type='primary'
        onClick={() => {
          browserRedirect(system.router.mallBaseUrl)
        }}
      >
        返回网站首页
      </Button>
      <Button
        type='primary'
        onClick={() => {
          browserRedirect(
            normalizeUrl(
              system.router.memberBaseUrl,
              AUDIT_PERSON_CREATE_PAGE_PATH
            )
          )
        }}
      >
        前往实名认证
      </Button>
    </Flex>
  )

  const { styles } = useRegisterStyles()

  return (
    <Result
      className={styles.result}
      extra={extra}
      status='success'
      subTitle={subTitle}
      title='注册成功'
    />
  )
}
